import React from 'react';
import {RadioButton} from 'material-ui/RadioButton';
import MultipleSelectField from 'components/pure/utils/select-field/MultipleSelectField';
import {VotingRadioButtonsSearchFieldValue} from 'actions/search/VotingRadioButtonsSearchFieldActions';
import VotingRadioButtonsSearchFieldActions from 'actions/search/VotingRadioButtonsSearchFieldActions';
import {List} from 'immutable';
import {VotingSearchValue} from 'stores/search/voting/VotingRadioButtonsSearchFieldStore';
import 'styles/search/VotingRadioButtonDropdownGroup.styl';

const VOTING_SECOND_LEVEL_DATA_KEYS = {
  team: {name: 'team', noResultsMessage: 'No team found'},
  department: {name: 'department', noResultsMessage: 'No department found'},
};

/**
 * Render the radio button + dropdown of the following voting components:
 * - Member of team
 * - Member of department
 */
export default class VotingRadioButtonDropdownGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
    };
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (!nextProps.checked) {
      const teamOrDepartmentIds = this._currentItems();
      if (teamOrDepartmentIds && teamOrDepartmentIds.length > 0) {
        const changeVotingValue = this._changeVotingValue(teamOrDepartmentIds[0]);
        setTimeout(
          VotingRadioButtonsSearchFieldActions.removeVotingValue.defer(changeVotingValue),
          0
        );
      }
    }
  }

  /** Render <RadioButton/> whose inner component includes a label + a dropdown */
  render() {
    return (
      <div>
        <RadioButton
          onCheck={this.props.onChangeGroupButton}
          checked={this.props.checked}
          label={this.props.label}
          style={this.props.style}
          value={this.props.value}
        />
        <MultipleSelectField
          style={{marginLeft: '40px'}}
          removeItem={this._removeVotingDropdownItem}
          selectField={{
            name: this.props.value,
            className: 'voting-search-sidebar-select-field',
            placeholder: 'Search...',
            noResultsMessage: VOTING_SECOND_LEVEL_DATA_KEYS[this.props.dataKey].onResultsMessage,
            options: this._selectFieldOptions(),
            onChange: this._onChangeSearchField,
            onSearchChange: this._onSearchChangeInField,
            search: this.state.searchTerm,
            filterOptions: options => options,
          }}
          selectedList={{
            containerClassname: 'combobox-list-container',
            listClassname: 'combobox-list',
            spanClassname: 'combobox-span',
            items: this._currentItems(),
          }}
        />
      </div>
    );
  }

  /** Return all the teams/departments for the user */
  _allItems() {
    if (this.props.dataKey === VOTING_SECOND_LEVEL_DATA_KEYS.team.name) {
      return this.props.store ? this.props.store.teams : [];
    } else if (this.props.dataKey === VOTING_SECOND_LEVEL_DATA_KEYS.department.name) {
      return this.props.store ? this.props.store.departments : [];
    }
    return [];
  }

  /** Remove an item from the voting dropdown */
  _removeVotingDropdownItem = item => {
    let votingValue = this.props.store.votingValue;
    let values = List(votingValue.values)
      .filterNot(value => value.includes(item.id))
      .toArray();
    if (values.length === 0) {
      values = null;
    }
    VotingRadioButtonsSearchFieldActions.changeVoting(
      VotingSearchValue({type: 'some_of', values: values})
    );
  };

  /** Return the current teams/departments selected by the user */
  _currentItems() {
    const votingValue = this.props.store.votingValue;
    if (votingValue && votingValue.values && votingValue.values[0].includes('.')) {
      const valueId = this._valueIdFrom(votingValue.values[0]);
      return List(this._allItems())
        .filter(value => {
          return value.id === valueId;
        })
        .toArray();
    }
    return null;
  }

  _valueIdFrom(valueStr) {
    return valueStr.split('.')[1];
  }

  /** Return a list of {value, label} options for the team/department in the dropdown group, depending on */
  _selectFieldOptions() {
    let options = this._allItems().map(item => {
      return {value: item.id, label: item.name};
    });
    if (this.state.searchTerm === null) {
      return options;
    } else {
      return options.filter(
        val => val.label.toLowerCase().indexOf(this.state.searchTerm.toLowerCase().trim()) !== -1
      );
    }
  }

  /** Callback when an `option.value` is chosen by the user */
  _onChangeSearchField = teamOrDepartmentId => {
    const teamOrDepartmentKey = this.props.value; // "team" OR "department"
    const changeVotingValue = this._changeVotingValue(teamOrDepartmentKey, teamOrDepartmentId);
    VotingRadioButtonsSearchFieldActions.changeVoting(changeVotingValue);
  };

  _changeVotingValue(key, teamOrDepartmentId) {
    // Use an action to trigger a team/department-voting search
    return VotingRadioButtonsSearchFieldValue({
      key: key,
      value: this.props.value + '.' + teamOrDepartmentId,
    });
  }

  /** Callback when the user changed the search term in the dropdown input text field which means we need to update the
   *  current teams/departments accordingly
   **/
  _onSearchChangeInField = searchTerm => {
    this.setState({searchTerm: searchTerm});
  };
}
